import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import CultivationUnitForm from '../Forms/CultivationUnitForm';

const AddEditCultivationUnitModal = ({
	dataCultivationUnit,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Unidad de Cultivo
			</ModalHeader>

			<CultivationUnitForm
				dataCultivationUnit={dataCultivationUnit}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditCultivationUnitModal;
